﻿$.fn.dxCtrlCompteEmailConfigEnvoiDns = function custom_dxCtrlCompteEmailConfigEnvoiDns(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcompteemailconfigenvoidns dx-ctrl");
        this.createInstance(new cdxCtrlCompteEmailConfigEnvoiDns(this, option));
    }
    return this;
}

window.cdxCtrlCompteEmailConfigEnvoiDns = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivContainer = null
    var $DivContainerDns = null

    var jauge = null
    var trSpf = null
    var $TdSpf = null
    var trDkim = null
    var $TdDkim = null
    var $TdResume = null;
    function mConstruit() {
        container.empty();

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        //jauge.mShow()

        $DivContainer = $("<div style=''/>").appendTo(container)
        $DivContainerDns = $("<div style='display:none;padding:5px;background-color:" + theme.backgroundColorTitle + "'/>").appendTo(container)

        option.bddCtrl.mAjaxCall({ command: "isemailfromfai", adresse_email: option.adresse_email }, function (data) {
            if (data.isfromfai == "1") {
                //on a un email gratuit
                $("<div style='padding-top:10px;'>Votre adresse email dépend d'un service de messagerie gratuit comme Gmail ou Yahoo.</div>").appendTo($DivContainer)
                //if (option.bddCtrl.objCptCli.objetMetier.hasServeurSmtpDedie() && !option.envoiQuotidien) {
                //    //on a un serveur smtp dédié et on est pas en envoi en nombre
                //    $("<div style='padding-top:10px;'>Vos emails seront envoyés avec l'adresse<br/><u>" + option.bddCtrl.objCptCli.data.smtp_dedie_email + "</u><br/>via votre smtp dédié.</div>").appendTo($DivContainer)
                //} else {
                //on est en envoi en nombre
                if (!option.envoiQuotidien) {
                    var $Div = $("<div style='color:red;padding-top:10px;'>Nous vous encourageons à envisager d'acheter un domaine ou d'utiliser un domaine que vous possédez déjà pour éviter les problèmes avec les politiques antispam des hébergeurs.</div>").appendTo($DivContainer)
                }
                $("<div style='padding-top:10px;'>Vos emails seront envoyés avec l'adresse<br/><u>" + option.adresse_email.replace("@", "-").remplacerTout(".", "-") + "@" + ((option.envoiQuotidien) ? parametre.domaine_email_mut_quo : parametre.domaine_email_mut_lead) + "</u><br/>via les serveurs SMTPs mutualisés de " + parametre.nom + ".</div>").appendTo($DivContainer)
                //}
                $("<div style='padding-top:10px;'>Les réponses de vos destinataires à vos emails seront toujours envoyées à votre adresse d'expéditeur <br/><u>" + option.adresse_email + "</u></div>").appendTo($DivContainer)

                if (option.bddCtrl.objCptCli.objetMetier.hasOptionDomaineDedie()) {
                    //on à l'option domaines dédiés
                    $("<div style='padding-top:10px;font-weight:bold;color:orange;' class='sate-hover'>Vous disposez de l'option domaine dédié. Nous vous conseillons de passer par votre ou vos domaines dédiés (et l'email attaché à ce domaine) pour vos emailing.</div>").appendTo($DivContainer).on("click", function (e) { window.open(parametre.url_cognoss + "//0/19/Utiliser_un_domaine_dedie/bc", "_blank") })
                }

                jauge.mHide()
            } else {
                //on a un email normal avec un domaine privé
                $("<div style=''>Votre adresse email dépend d'un domaine professionnel (<b>" + option.adresse_email.split("@")[1] + "</b>).</div>").appendTo($DivContainer)
                //if (option.bddCtrl.objCptCli.objetMetier.hasServeurSmtpDedie() && !option.envoiQuotidien) {
                //    $("<div style='padding-top:10px;'>Vous disposez d'un serveur smtp dédié.</div>").appendTo($DivContainer)
                //    $("<div style='padding-top:10px;'>Vos emails seront envoyés avec l'adresse <br/><u>" + option.bddCtrl.objCptCli.data.smtp_dedie_email + "</u><br/><b>via votre smtp dédié</b>.</div>").appendTo($DivContainer)
                //    $("<div style='padding-top:10px;'>Les réponses de vos destinataires à vos emails seront toujours envoyées à votre adresse d'expéditeur<br/><u>" + option.adresse_email + "</u></div>").appendTo($DivContainer)
                //} else {
                $("<div style='padding-top:10px;'>Les réponses de vos destinataires à vos emails seront toujours envoyées à votre adresse d'expéditeur<br/><u>" + option.adresse_email + "</u></div>").appendTo($DivContainer)

                //$("<div style='padding-top:10px;'>Vos emails seront envoyés via l'adresse<br/><u>" + option.adresse_email.replace("@", "-").remplacerTout(".", "-") + "@" + ((option.envoiQuotidien) ? parametre.domaine_email_mut_quo : parametre.domaine_email_mut_lead) + "</u><br/>via les serveurs SMTPs mutualisés de " + parametre.nom + ".</div>").appendTo($DivContainer)
                //}

                if (option.allowSave) {
                    if (option.bddCtrl.objCptCli.objetMetier.hasOptionDomaineDedie()) {
                        //on à l'option domaines dédiés
                        var currentDomaine = option.adresse_email.split("@")[1]
                        option.bddCtrl.mAjaxCall({ command: "getlstdomainededie" }, function (data) {
                            if (typeof data.lst_domaine == 'undefined') data.lst_domaine = []
                            if (data.lst_domaine.filter(function (o) { return o.domaine == currentDomaine }).length > 0) {
                                //le domaine du mail est dans les domaines dédié
                                $("<div style='padding-top:10px;'>Vos emails seront envoyés via l'adresse<br/><u>" + option.adresse_email + "</u><br/>via les serveurs SMTPs mutualisés de " + parametre.nom + ".</div>").appendTo($DivContainer)

                                var $DivDomaineDedie = $("<div style='padding-top:10px;'>Le domaine de l'email <b>" + currentDomaine + "</b> fait partie de vos domaines dédiés</div>").appendTo($DivContainer)
                                option.bddCtrl.mAjaxCall({
                                    command: "getdnsdomaineverif",
                                    domaine: currentDomaine
                                }, function (data) {
                                    var $Table = $("<table style='width:100%;'/>").appendTo($DivDomaineDedie)
                                    var $Tr = $("<tr/>").appendTo($Table)
                                    if (data.lstdns.filter(function (dns) { return dns.current_value != dns.data.substring(0, dns.data.length - 1) }).length == 0) {
                                        $Table.css("color", "green")
                                        $("<td style='width:1px'><i class='fas fa-thumbs-up' title='Le domaine est correctement configuré.'></i></td>").appendTo($Tr)
                                        $("<td>Les DNS de votre domaine sont correctement configurés</td>").appendTo($Tr)
                                    } else {
                                        $Table.css("color", "red")
                                        $("<td style='width:1px'><i class='fas fa-triangle-exclamation' title='Le domaine n'est pas correctement configuré.'></i></td>").appendTo($Tr)
                                        $("<td>Les DNS de votre domaine ne sont pas correctement configurés</td>").appendTo($Tr)
                                    }
                                    $DivDomaineDedie.addClass("state-hover")
                                    $DivDomaineDedie.on("click", function (e) {
                                        var popupDns = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                            fullScreen: false,
                                            showMaximize: false,
                                            title: "Vérifier les DNS",
                                            height: "auto",
                                            maxHeight: "100%",
                                            width: 750,
                                            contentTemplate: function (contentElement) {
                                                contentElement.css("padding-top", "0px")
                                                var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                                                $("<div style='height:100%;min-height:200px;'/>").appendTo(dxScroll.content()).dxCtrlDomaineDedieDns({
                                                    bddCtrl: option.bddCtrl,
                                                    domaine: currentDomaine
                                                }).dxCtrlDomaineDedieDns("instance")
                                            },
                                            onHiden: function (e) {
                                                mRempliDomaineDedie(contentElement)
                                            }
                                        }).dxCtrlPopupBase("instance")
                                        popupDns.show()
                                    })
                                })
                            } else {
                                //le domaine du mail n'est pas dans les domaines dédié
                                $("<div style='padding-top:10px;'>Vos emails seront envoyés via l'adresse<br/><u>" + option.adresse_email.replace("@", "-").remplacerTout(".", "-") + "@" + ((option.envoiQuotidien) ? parametre.domaine_email_mut_quo : parametre.domaine_email_mut_lead) + "</u><br/>via les serveurs SMTPs mutualisés de " + parametre.nom + ".</div>").appendTo($DivContainer)

                                $("<div style='padding-top:10px;color:red;'>Le domaine de l'email <b>" + currentDomaine + "</b> ne fait pas partie de vos domaines dédiés</div>").appendTo($DivContainer)
                                var $A = $("<a href='javascript:void(0)'>Rajouté le domaine <b>" + currentDomaine + "</b> parmi vos domaine dédié</a>").appendTo($DivContainer)
                                $A.on("click", function (e) {
                                    var dxWizard = $("<div/>").appendTo("body").dxCtrlWizardDomaineDedie({
                                        bddCtrl: option.bddCtrl,
                                        domaine: currentDomaine,
                                        onClose: function (e) {
                                            mConstruit()
                                        }
                                    })
                                    dxWizard.show()
                                })
                            }
                        })
                    } else {
                        $("<div style='padding-top:10px;'>Vos emails seront envoyés via l'adresse<br/><u>" + option.adresse_email.replace("@", "-").remplacerTout(".", "-") + "@" + ((option.envoiQuotidien) ? parametre.domaine_email_mut_quo : parametre.domaine_email_mut_lead) + "</u><br/>via les serveurs SMTPs mutualisés de " + parametre.nom + ".</div>").appendTo($DivContainer)
                        //l'option des domaines dédiés n'est pas activé
                        if (!option.bddCtrl.nom_base.endsWith("_aagest")) {
                            var $A = $("<a href='javascript:void(0)' title='Augmenter votre délivrabilité avec les domaines dédiés'>Activer l'option <b>domaine dédié</b></a>").appendTo($DivContainer)
                            $A.on("click", function (e) {
                                $("<div/>").appendTo("body").dxCtrlAchatPopup({
                                    bddCtrl: option.bddCtrl,
                                    typeProduit: "domaine_dedie",
                                    onPaiement: function () {
                                        option.bddCtrl.objCptCli.data.date_fin_email_pub = option.bddCtrl.objCptCli.data.offre_date_fin
                                        //option.bddCtrl.objCptCli.data.date_fin_email_pub = (new Date()).addMonths(12)
                                        mNotify("L'utilisation de domaines dédiés pour vos emailings est activé.<br/><a href='javascript:voiud(0)'>En savoir plus sur les domaines dédiés</a>", "success", 9000, function () {
                                            window.open(parametre.url_cognoss + "//0/19/Utiliser_un_domaine_dedie/bc")
                                        })
                                    }
                                })
                            })
                        }
                    }
                }

            }
        })

    }

    var dkimOk = false
    var spfOk = false
    var spfActuel = ""
    var spfNew = ""
    function mVerifyCname(funcOk) {
        var domaine = option.adresse_email.split("@")[1]
        option.bddCtrl.mAjaxCall({ command: "verifycnameemail", domaine: domaine }, function (data) {
            dkimOk = (data.dkimok == "1")
            spfOk = (data.spfok == "1")
            spfActuel = data.spfactuel
            spfNew = data.spfnew

            if (typeof funcOk != 'undefined') funcOk()
        })
    }

    function mRempliDns() {
        var domaine = option.adresse_email.split("@")[1]
        var nomHoteDkim = "popsoftkey._domainkey." + domaine + "."
        var cNameDkim = "secure._domainkey.popsoft.fr."
        $DivContainerDns.css("height", (($DivContainerDns.innerHeight() > 0) ? $DivContainerDns.innerHeight() + "px" : 0))
        $DivContainerDns.empty()


        if (!dkimOk || !spfOk) {
            $("<table style='padding-top:20px;padding-left:20px;'><tr><td style='width:1px;font-size:260%;font-weight:bold;padding-right:5px;' class='dx-theme-accent-as-text-color'>➀</td><td>Accédez à votre fournisseur DNS sur le domaine <b>" + domaine + "</b>.</td></tr></table>").appendTo($DivContainerDns)
        }
        if (!dkimOk) {
            $("<table style='padding-bottom:0px;padding-left:20px;'><tr><td style='width:1px;font-size:260%;font-weight:bold;padding-right:5px;' class='dx-theme-accent-as-text-color'>➁</td><td>Ajoutez l'enregistrement CNAME suivant:</td></tr></table>").appendTo($DivContainerDns)
        }

        var $Table = $("<table style='width:100%;font-family:barlow condensed;'/>").appendTo($DivContainerDns)

        if (!dkimOk) {
            var $Tr = $("<tr style='opacity:0.3;font-size:80%'/>").appendTo($Table)
            var $Td = $("<tdstyle='width:35px'></td>").appendTo($Tr)
            var $Td = $("<td style='width:52px;'>Type</td>").appendTo($Tr)
            var $Td = $("<td></td>").appendTo($Tr)
            var $Td = $("<td>Nom d'hôte (hostname)</td>").appendTo($Tr)
            var $Td = $("<td>Entrez cette valeur</td>").appendTo($Tr)

            var $Tr = $("<tr style='opacity:0.3;'/>").appendTo($Table)
            var $Td = $("<td colspan='5'><hr style='margin:0;'/></td>").appendTo($Tr)

            trDkim = $("<tr style=''/>").appendTo($Table)
            var $Td = $("<td style='padding:5px;opacity:0.2;'>DKIM</td>").appendTo(trDkim)
            var $Td = $("<td style='padding:5px;'><div style='border:" + theme.border + ";padding:3px;text-align:center;'>CNAME</div></td>").appendTo(trDkim)
            $TdDkim = $("<td style='padding:5px;font-size:180%;color:" + ((dkimOk) ? "green" : "red") + ";'><i class='fas fa-" + ((dkimOk) ? "thumbs-up" : "thumbs-down") + "'></i></td>").appendTo(trDkim)
            var $Td = $("<td style='padding:5px;'>" + nomHoteDkim + "</td > ").appendTo(trDkim)
            var $I = $("<i class='fas fa-copy state-hover dx-theme-accent-as-text-color' style='margin-left:5px;'></i>").appendTo($Td)
            $I.on("click", function (e) {
                e.stopPropagation()
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val(nomHoteDkim).select();
                document.execCommand("copy");
                $temp.remove();
                mNotify("Le nom d'hôte <b>" + nomHoteDkim + "</b> a été copié dans le presse papier", "success", 3000)
            })

            var $Td = $("<td style='padding:5px;'>" + cNameDkim + "</td>").appendTo(trDkim)
            var $I = $("<i class='fas fa-copy state-hover dx-theme-accent-as-text-color' style='margin-left:5px;'></i>").appendTo($Td)
            $I.on("click", function (e) {
                e.stopPropagation()
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val(cNameDkim).select();
                document.execCommand("copy");
                $temp.remove();
                mNotify("La valeur du CNAME <b>" + cNameDkim + "</b> a été copiée dans le presse papier", "success", 3000)
            })


            var $Tr = $("<tr style='opacity:0.3;'/>").appendTo($Table)
            var $Td = $("<td colspan='5'><hr style='margin:0;'/></td>").appendTo($Tr)
        }

        var $Tr = $("<tr style=''/>").appendTo($Table)
        var $Td = $("<td colspan='5'></td>").appendTo($Tr)
        if (!spfOk) {
            if (spfActuel.length == 0) {
                $("<table style='padding:20px 0 5px 20px;'><tr><td style='width:1px;font-size:260%;font-weight:bold;padding-right:5px;' class='dx-theme-accent-as-text-color'>" + ((!dkimOk && !spfOk) ? "➂" : "➁") + "</td><td>Créer l'enregistrement SPF (TXT) de votre domaine:</Td></tr></table>").appendTo($Td)
            } else {
                $("<table style='padding:20px 0 0px 20px;'><tr><td style='width:1px;font-size:260%;font-weight:bold;padding-right:5px;' class='dx-theme-accent-as-text-color'>" + ((!dkimOk && !spfOk) ? "➂" : "➁") + "</td><td>Modifiez l'enregistrement SPF (TXT) de votre domaine:</td></tr></table>").appendTo($Td)
            }
        }

        //var $Table = $("<table style='width:100%;font-family:barlow condensed;'/>").appendTo($DivContainerDns)
        if (!spfOk) {
            var $Tr = $("<tr style='opacity:0.3;font-size:80%'/>").appendTo($Table)
            var $Td = $("<td style='width:35px'></td>").appendTo($Tr)
            var $Td = $("<td style='width:52px;'>Type</td>").appendTo($Tr)
            var $Td = $("<td></td>").appendTo($Tr)
            var $Td = $("<td>Nom d'hôte (hostname)</td>").appendTo($Tr)
            var $Td = $("<td>Valeur</td>").appendTo($Tr)

            var $Tr = $("<tr style='opacity:0.3;'/>").appendTo($Table)
            var $Td = $("<td colspan='5'><hr style='margin:0;'/></td>").appendTo($Tr)

            trSpf = $("<tr style=''/>").appendTo($Table)
            var $Td = $("<td style='padding:5px;opacity:0.2;'>SPF</td>").appendTo(trSpf)
            var $Td = $("<td style='padding:5px;'><div style='border:" + theme.border + ";padding:3px;text-align:center;'>TXT</div></td>").appendTo(trSpf)
            $TdSpf = $("<td style='padding:5px;font-size:180%;color:" + ((spfOk) ? "green" : "red") + ";'><i class='fas fa-" + ((spfOk) ? "thumbs-up" : "thumbs-down") + "'></i></td>").appendTo(trSpf)
            var $Td = $("<td style='padding:5px;'>" + domaine + "</td>").appendTo(trSpf)
            var $I = $("<i class='fas fa-copy state-hover dx-theme-accent-as-text-color' style='margin-left:5px;'></i>").appendTo($Td)
            $I.on("click", function (e) {
                e.stopPropagation()
                var $temp = $("<input>");
                $("body").append($temp);
                $temp.val(domaine).select();
                document.execCommand("copy");
                $temp.remove();
                mNotify("Le nom d'hôte <b>" + domaine + "</b> a été copié dans le presse papier", "success", 3000)
            })

            if (spfOk) {
                var $Td = $("<td style='padding:5px;'>" + spfActuel + "</td>").appendTo(trSpf)
            } else {
                var $Td = $("<td style='padding:5px;'><span style='opacity:0.3;'>Valeur actuelle</span><br/><span style='text-decoration:line-through'>" + ((spfActuel.length == 0) ? "(aucun spf)" : spfActuel) + "</span><br/><span style='opacity:0.3;'>Nouvelle valeur à saisir</span><br/><span>" + spfNew + "</span></td>").appendTo(trSpf)

                var $I = $("<i class='fas fa-copy state-hover dx-theme-accent-as-text-color' style='margin-left:5px;'></i>").appendTo($Td)
                $I.on("click", function (e) {
                    e.stopPropagation()
                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val(spfNew).select();
                    document.execCommand("copy");
                    $temp.remove();
                    mNotify("La valeur du CNAME <b>" + spfNew + "</b> a été copiée dans le presse papier", "success", 3000)
                })
            }

            var $Tr = $("<tr style='opacity:0.3;'/>").appendTo($Table)
            var $Td = $("<td colspan='5'><hr style='margin:0;'/></td>").appendTo($Tr)
        }

        var $Table = $("<table style='width:100%;padding-top:20px;'/>").appendTo($DivContainerDns)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Vérifier",
            onClick: function (e) {
                jauge.mShow();
                mVerifyCname(function () {
                    jauge.mHide();
                    mRempliDns()
                })
            }
        })

        var txtHtmlResume = ""
        if (dkimOk) {
            txtHtmlResume = "<div style='color:green'>Votre enregistrement DKIM est ok</div>"
        } else {
            txtHtmlResume = "<div style='color:red'>Votre enregistrement DKIM est incorrecte</div>"
        }

        if (spfOk) {
            txtHtmlResume += "<div style='color:green'>Votre enregistrement SPF est ok</div>"
        } else {
            txtHtmlResume += "<div style='color:red'>Votre enregistrement SPF est incorrecte</div>"
        }

        $TdResume = $("<td style='width:100%;padding-left:5px;'>" + txtHtmlResume + "</td>").appendTo($Tr)

        option.bddCtrl.mAjaxCall({ command: "isemailfromfai", adresse_email: option.adresse_email }, function (data) {
            if (data.isfromfai == "1") {
                $("<div style='color:orange;padding-top:20px;font-size:80%;'>Il semble que vous utilisez une adresse mail dépendant d'un FAI (type gmail, orange, etc...). De ce fait, vous n'avez pas accès au DNS pour les modifier. Nous vous déconseillons fortement d'utiliser cette adresse email pour vos mailing.<br/>Utilisez plutôt une adresse email dépendant d'un nom de domaine sur lequel vous pouvez gérer les DNS.</div>").appendTo($DivContainerDns)
            }
        })

        $DivContainerDns.css("height", "")
    }

    this.mReload = function () {
        mConstruit()
    }

    this.element = function () { return container }

    mConstruit();
}